export default (state, profile) => {
  state.profile = profile;
}
